import { useState, useEffect, useCallback } from 'react';
import axios, { API, authHeaders, errText } from '../api';
import Layout from './Layout';
import { ui } from '../ui';
import DataTable from '../components/DataTable';

export default function Packages() {
  const [items, setItems] = useState([]);
  const [sparkAmount, setSparkAmount] = useState('');
  const [priceRub, setPriceRub] = useState('');
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editAmount, setEditAmount] = useState('');
  const [editPrice, setEditPrice] = useState('');
  const [saving, setSaving] = useState(false);

  const fetchItems = useCallback(() => {
    axios.get(`${API}/admin/packages`, { headers: authHeaders() }).then(r => setItems(r.data));
  }, []);
  useEffect(() => { fetchItems(); }, [fetchItems]);

  const create = async () => {
    if (!sparkAmount || !priceRub) return;
    setError('');
    setCreating(true);
    try {
      await axios.post(`${API}/admin/packages`, {
        spark_amount: Number(sparkAmount), price_rub: Number(priceRub), sort_order: items.length,
      }, { headers: authHeaders() });
      setSparkAmount(''); setPriceRub('');
      fetchItems();
    } catch (e) {
      setError(errText(e, 'Не удалось создать пакет'));
    }
    setCreating(false);
  };

  const toggleActive = async (p) => {
    setError('');
    try {
      await axios.patch(`${API}/admin/packages/${p.id}`, { is_active: !p.is_active }, { headers: authHeaders() });
    } catch (e) {
      setError(errText(e, 'Не удалось изменить видимость пакета'));
    }
    fetchItems();
  };

  const startEdit = (p) => {
    setError('');
    setEditingId(p.id);
    setEditAmount(String(p.spark_amount));
    setEditPrice(String(p.price_rub));
  };

  const cancelEdit = () => setEditingId(null);

  const saveEdit = async (id) => {
    if (!editAmount || !editPrice) return;
    setError('');
    setSaving(true);
    try {
      await axios.patch(`${API}/admin/packages/${id}`, {
        spark_amount: Number(editAmount), price_rub: Number(editPrice),
      }, { headers: authHeaders() });
      setEditingId(null);
      fetchItems();
    } catch (e) {
      setError(errText(e, 'Не удалось сохранить изменения'));
    }
    setSaving(false);
  };

  return (
    <Layout>
      <h1 style={ui.title}>Пакеты искр</h1>

      <div style={ui.card}>
        <div style={{ fontWeight: 600, marginBottom: 12 }}>Новый пакет</div>
        <div style={ui.row}>
          <input style={ui.input} type="number" placeholder="Кол-во искр" value={sparkAmount} onChange={e => setSparkAmount(e.target.value)} />
          <input style={ui.input} type="number" placeholder="Цена, ₽" value={priceRub} onChange={e => setPriceRub(e.target.value)} />
          <button style={ui.btn} onClick={create} disabled={creating}>{creating ? 'Создаём…' : 'Создать'}</button>
        </div>
        {error && <div style={ui.error}>{error}</div>}
      </div>

      <div style={ui.card}>
        <DataTable
          rows={items}
          rowKey={p => p.id}
          emptyText="Пакетов пока нет"
          columns={[
            {
              key: 'spark_amount', label: 'Искры',
              render: p => editingId === p.id
                ? <input style={{ ...ui.input, width: 90 }} type="number" value={editAmount} onChange={e => setEditAmount(e.target.value)} />
                : p.spark_amount,
            },
            {
              key: 'price_rub', label: 'Цена',
              render: p => editingId === p.id
                ? <input style={{ ...ui.input, width: 90 }} type="number" value={editPrice} onChange={e => setEditPrice(e.target.value)} />
                : `${p.price_rub} ₽`,
            },
            { key: 'price_per_spark', label: 'Цена за искру', sortValue: p => p.price_rub / p.spark_amount, render: p => `${Math.round(p.price_rub / p.spark_amount)} ₽` },
            { key: 'is_active', label: 'Видимость', sortValue: p => (p.is_active ? 1 : 0), render: p => (p.is_active ? 'Показывается' : 'Скрыт') },
            {
              key: 'actions', label: '', sortable: false,
              render: p => editingId === p.id ? (
                <div style={{ display: 'flex', gap: 8 }}>
                  <button style={ui.btn} onClick={() => saveEdit(p.id)} disabled={saving}>{saving ? 'Сохраняем…' : 'Сохранить'}</button>
                  <button style={ui.btnSecondary} onClick={cancelEdit} disabled={saving}>Отмена</button>
                </div>
              ) : (
                <div style={{ display: 'flex', gap: 8 }}>
                  <button style={ui.btnSecondary} onClick={() => startEdit(p)}>Изменить</button>
                  <button style={ui.btnSecondary} onClick={() => toggleActive(p)}>
                    {p.is_active ? 'Скрыть' : 'Показать'}
                  </button>
                </div>
              ),
            },
          ]}
        />
      </div>
    </Layout>
  );
}
